export const EmailIcon = () => {
  return (
    <>
      <svg
        width='19'
        height='20'
        viewBox='0 0 19 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <title>Email Icon</title>
        <path
          d='M17.5 18.5L14.7222 15.5541'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M8.1499 12.6674C8.1499 13.7502 8.55551 14.7887 9.27755 15.5544C9.9996 16.3201 10.9788 16.7502 11.9999 16.7502C13.021 16.7502 14.0002 16.3201 14.7223 15.5544C15.4443 14.7887 15.8499 13.7502 15.8499 12.6674C15.8499 11.5845 15.4443 10.5461 14.7223 9.7804C14.0002 9.0147 13.021 8.58456 11.9999 8.58456C10.9788 8.58456 9.9996 9.0147 9.27755 9.7804C8.55551 10.5461 8.1499 11.5845 8.1499 12.6674Z'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M7.60003 17.3335H2.1C1.80827 17.3335 1.52847 17.2106 1.32218 16.9919C1.11589 16.7731 1 16.4763 1 16.167V7.41806L6.50002 12.0437'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M16.4001 7.41809L10.3082 1.74103C10.1024 1.50719 9.85342 1.32074 9.57673 1.19326C9.30012 1.06578 9.00165 1 8.70003 1C8.39841 1 8.09994 1.06578 7.82333 1.19326C7.54665 1.32074 7.29766 1.50719 7.09182 1.74103L1 7.41809'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M5.90747 11.546L3.75 13.8339'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </>
  );
};
